import { withStyles } from "@material-ui/core/styles";
import cx from "classnames";
import { useEffect, useRef } from "react";

const styles = props => ({
  stopScroll: {
    overflow: "hidden"
  },
  close: {
    margin: "-19px 10px 0 0",
    display: "flex",
    justifyContent: "flex-end",
    "& img": {
      cursor: "pointer"
    }
  },
  overlay: {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: "rgba(19, 29, 55, 0.4)",
    zIndex: 1000,
    overflow: "hidden"
  },
  overlayContainer: {
    background: "#ffffff",
    position: "relative",
    margin: "0 auto",
    width: props => props.modalWidth || "424px",
    top: "50%",
    border: "1px solid #E9ECF5",
    boxShadow: "0px 2px 5px rgba(1, 41, 75, 0.08)",
    borderRadius: "10px",
    textAlign: "center",
    padding: "30px 0 30px 0",
    transform: "translate(0, -50%)",
    ["@media (max-width:576px)"]: {
      transform: "none",
      border: "none",
      padding: 0
    },
    ["@media (min-width:576px)"]: {
      overflow: "scroll",
      "&::-webkit-scrollbar": { width: 0, height: "0" },
      scrollbarWidth: "none",
      maxHeight: "90%"
    }
  }
});

const Modal = props => {
  const {
    classes,
    isCloseButton,
    handleModalToggle,
    className,
    keepOutsideClickEvent = false,
    closeBtnStyle
  } = props;
  const modalRef = useRef(null);
  const handleClickOutside = event => {
    if (
      modalRef &&
      modalRef.current &&
      !modalRef.current.contains(event.target)
    ) {
      handleModalToggle();
    }
  };
  useEffect(() => {
    document.body.classList.add(classes.stopScroll);
    if (keepOutsideClickEvent)
      document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.body.classList.remove(classes.stopScroll);
      if (keepOutsideClickEvent)
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <div className={classes.overlay}>
        <div className={cx(className, classes.overlayContainer)} ref={modalRef}>
          {isCloseButton && (
            <div className={cx(classes.close, closeBtnStyle)}>
              <img
                className={closeBtnStyle}
                src="/hire/greyClose.svg"
                alt="close"
                onClick={handleModalToggle}
              />
            </div>
          )}

          {props.children}
        </div>
      </div>
    </>
  );
};
export default withStyles(styles)(Modal);
